import Link from "next/link";
import Button from "../ui/Button";
import CaseStudyCard from "../ui/CaseStudyCard";
import SectionTitle from "../ui/SectionTitle";

import { caseStudies } from "@/data/caseStudies";

interface CaseStudyProps {
  country?: string;
  limit?: number;
}

export default function CaseStudy({
  country,
  limit = 6,
}: CaseStudyProps) {
  // Filter only when country is provided
  const filteredCaseStudies = country
    ? caseStudies.filter(
        (study) =>
          study.country?.toLowerCase() === country.toLowerCase()
      )
    : caseStudies;

  const limitedCaseStudies = filteredCaseStudies.slice(0, limit);
  const half = Math.ceil(limitedCaseStudies.length / 2);

  return (
    <section className="py-12 lg:py-16 2xl:py-20 relative overflow-hidden">
      <div className="hidden xl:block absolute -left-300 top-0 w-full h-full z-0 bg-white/40 shadow-[0_4px_64px_rgba(0,0,0,0.05)] backdrop-blur-[17.5px] transform -skew-x-24"></div>

      <div className="custom-container mx-auto relative z-10">
        <div className="xl:mb-20 mb-10">
          <SectionTitle
            title="Predictable & Measurable Outcomes"
            subtitle="Fueling Industry Growth with"
            align="left"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:gap-x-16 2xl:gap-x-24 gap-x-5 relative">
          <div className="flex flex-col xl:gap-24 gap-10">
            {limitedCaseStudies.slice(0, half).map((study, index) => (
              <CaseStudyCard key={index} {...study} />
            ))}
          </div>

          <div className="flex flex-col xl:gap-24 xl:mt-32 mt-10 gap-10">
            {limitedCaseStudies.slice(half).map((study, index) => (
              <CaseStudyCard key={index + half} {...study} />
            ))}
          </div>
        </div>

        <div className="text-center xl:mt-16 mt-5">
          <Link href="/case-study">
            <Button
              responsiveSize={{
                mobile: "md",
                desktop: "lg",
              }}
              variant="primary"
            >
              View All
            </Button>
          </Link>
        </div>

        <div className="sr-only" aria-hidden>
          {limitedCaseStudies.map((s, i) => (
            <Link key={i} href={s.path} prefetch>
              {s.company}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}